import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";

import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import {
  PopupCustomerModule,
  PopupFabricStyleModule,
} from "../modules/ModuleUtil.js";
import {
  AddIcon,
  CameraIcon,
  CancelIcon,
  DeleteIcon,
  DropDwnDown,
  DropDwnUp,
  UploadDocIcon,
} from "../gui_components/Icons.js";
import { ReportService } from "../services/ReportService.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { BaseBean, RestReportBean } from "../ds/client_ds.js";
import {
  FabricStyleBean,
  FabricStyleSearchCriteria,
  InvoiceFabricStyleSoldYearlyInquiryDetailsRequest,
  InvoiceYearlyInquiryCriteria,
  RestFabricStyleListBeanRequest,
  RestPageListBean,
  RestReadRequest,
  FabricStyleCatalogueDetailInquiryCriteriaBean,
  FabricStyleCatalogueProductDetailCriteria,
  FabricStyleColorBean,
  ProductCatalogPrintRequest,
  PageListBean
} from "../ds/ds.js";
import {
  AlertToolBox,
  CollapseComponent,
  ColumnDefinition,
  DatePickerComponent_adv,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import CustomTable from "../gui_components/CustomTable.js";
class FabricCatalog extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Fabric Catalog Generation",
      isShowExecuteButton: true,
      isShowExitButton: true,
      isShowClearCriteriaButton: true,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      criteria: new FabricStyleCatalogueDetailInquiryCriteriaBean(),
      inquiryDataList: [],
      isInquiryDatasFound: false,
      fabricStyleData: new FabricStyleBean(),
      colorList: [],
      warehouses: [],
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      error_list: [],
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      fabricPageListForAutoCompleteList: new Array(),
      showAutoCompleteFabricList: true,
      fabricColourPageListForAutoCompleteList: new Array(),
      showAutoCompleteFabricColorList: true,
      isShowFabricStyleModule: false,
      isShowCustomerModule: false,
      moduleForPopup: [],
      isDisableFields: false,
      isShowLookUp: true,
      isShowColorLookup: false,
      colorLookupHandler: null,
      isCollapsible_open: true,
      fabricDatas: [],
      showAutoCompleteMultiFabricList: true,
      multiFabricPageListForAutoCompleteList: new Array(),
      fabricStyleData: new FabricStyleBean(),
      multiFabricCode: "",
      is3PL: false,
      url: [],
      isShowColorPopUp: false,
      isShowColorLineAlert: false,
      main_bean: Object.assign(new FabricStyleCatalogueProductDetailCriteria(), {
        fabricStyleCode: "",
        fabricStyleName: "",
        colorCodes: [],
      }),
      colorList: [],
      selectedMultipleColorList: [],
      // True when the Color Popup was opened by clicking the Fabric Style
      // hyperlink on an existing row (selectedMultipleColorList is then the
      // full, authoritative set of colors for that row). False for a fresh
      // typed Fabric Style entry, where selectedMultipleColorList only holds
      // colors picked in this session and should be unioned with any
      // existing saved colors instead of replacing them.
      isReopenedViaHyperlink: false,
    };
    this.fabricCodeRef = React.createRef();
    this.multiFabricCodeRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    this.report_url = appData.reportURL;
    this.initLookupHandlers();
  }
  hideAlertCallBackColor = (mslgType, isDisplayed) => {
    this.setState({
      // isShowColorPopUp: isDisplayed,
      isShowColorLineAlert: isDisplayed,
    });
  };

  /**
   * Central helper for putting the FabricStyle InputTextbox back into a
   * clean, searchable state.
   *
   * InputTextbox keeps its own internal lookup/autocomplete state alongside
   * the value prop, so clearing main_bean alone isn't enough to re-arm
   * lookup/autocomplete - it has to be reset imperatively via the ref too.
   * And because .clear() does NOT fire onChange, the suggestion list and the
   * showAutoCompleteFabricList flag have to be reset here explicitly or the
   * next typed value silently produces no suggestions.
   */
  resetFabricAutoComplete = (shouldFocus = true) => {
    if (this.fabricCodeRef.current != null) {
      this.fabricCodeRef.current.clear();
      if (shouldFocus) {
        this.fabricCodeRef.current.focus();
      }
    }
  };

  closeAlertMultipleColorModalCallBack = (isShowPopup) => {
    this.setState({
      isShowColorPopUp: isShowPopup,
      // isShowColorLineAlert: isShowPopup,
      colorList: [],
      selectedMultipleColorList: [],
      // Popup is closing without an Add Catalog, so it should behave as if
      // no fabric is selected: reset main_bean the same way MultipleAddLines
      // does on a successful save, rather than leaving it holding whatever
      // row's data handleLineNumberClick loaded into it. Otherwise the
      // fabricStyleCode/fabricStyleName InputTextboxes stay stuck showing
      // that row's stale values.
      main_bean: Object.assign(new FabricStyleCatalogueProductDetailCriteria(), {
        fabricStyleCode: "",
        fabricStyleName: "",
        colorCodes: [],
      }),
      // Not reopened via hyperlink anymore - main_bean is blank now, so the
      // next Add Catalog is a fresh entry, not a re-save of the row that
      // was just being viewed.
      isReopenedViaHyperlink: false,
      // Re-arm autocomplete. The imperative .clear() below does not fire
      // onChange, so without these two the next search after closing the
      // popup would render no suggestions.
      fabricPageListForAutoCompleteList: [],
      showAutoCompleteFabricList: true,
    });

    this.resetFabricAutoComplete();
  };
  getImageURL = () => {
    const { appData } = this.context;
    let serviceURL = appData.serviceURL;
    let imageURL = serviceURL + "/image?file=";
    return imageURL;
  };
  initLookupHandlers = () => {
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      "Fabric Style"
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  execute = () => {
    //this.hideAlertCallBack();
    this.loadPage();
  };
  errorCallBack = (error) => {
    ShowError("Error : ", error);
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: " ",
    });
  };
  clearCriteria = () => {
    let criteria = new FabricStyleCatalogueDetailInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleName = "";
    criteria.multiFabricCode = "";
    this.setState({
      criteria: criteria,
      isShowLookUp: true,
      multiFabricCode: "",
      fabricDatas: [],
      fabricStyleData: new FabricStyleBean(),
      isShowColorLookup: false,
      isCollapsible_open: true,
      colorList: [],
      selectedMultipleColorList: [],
      // Blank out the top-level FabricStyle fields too, and re-arm the
      // autocomplete so a search immediately after Clear Criteria works.
      main_bean: Object.assign(new FabricStyleCatalogueProductDetailCriteria(), {
        fabricStyleCode: "",
        fabricStyleName: "",
        colorCodes: [],
      }),
      fabricPageListForAutoCompleteList: [],
      showAutoCompleteFabricList: true,
      isReopenedViaHyperlink: false,
    });
    this.resetFabricAutoComplete(false);
    this.hideAlertCallBack();
  };
  // resetInquiry = () => {
  //   let criteria = new InvoiceYearlyInquiryCriteria();
  //   criteria.companyCode = this.companyCode;
  //   criteria.fabricStyleName = "";
  //   criteria.multiFabricCode = "";
  //   this.setState({
  //     criteria: criteria,
  //     multiFabricCode: "",
  //     fabricDatas: [],
  //     fabricStyleData: new FabricStyleBean(),
  //     isInquiryDatasFound: false,
  //     inquiryDataList: new Array(),
  //     isShowColorLookup: false,
  //     isShowPDFButton: false,
  //     isShowExcelButton: false,
  //     isShowResetButton: false,
  //     isShowClearCriteriaButton: true,
  //     isDisableFields: false,
  //     isShowLookUp: true,
  //     isCollapsible_open: true,
  //   });
  //   this.hideAlertCallBack();
  // };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  loadPage = () => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    if (!isEmptyArray(criteria.fabricStyleDetails)) {
      let request = new ProductCatalogPrintRequest();
      request.criteria = criteria;
      let pageInput = new PageListBean();
      request.pageListBean = pageInput;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Executing... ",
      });
      this.loadInvoiceFabricStyleYearlyInquiryList(request);
    } else {
      let errList = [];
      let errMsg = "FabricDetails Required!"
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }

    // this.getColorUrl();
  };
  loadInvoiceFabricStyleYearlyInquiryList = (listRequest) => {
    //if (SecurityAccessManager.InvoiceFabricStyleYearlyInquiry_IsAccessible()) {
    ReportService.getProductCaltalog(
      listRequest,
      this.loadInvoiceFabricStyleYearlyInquiryPageResponse,
      this.errorCallBack
    );
    // } else {
    //   this.inValidAccess(1);
    // }
  };
  loadInvoiceFabricStyleYearlyInquiryPageResponse = (response) => {
    if (response.data != null && response.data.reportResult != null) {
      let reportFilePath = response.data.reportResult.reportFileID;
      window.open(this.report_url + reportFilePath);
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
      //   let downloadUrl = this.report_url + reportFilePath + "&is_attachment=true";
      // window.open(downloadUrl);
    }
    // this.showErrorMessage(response.data);
  };
  generatePDF = () => {
    this.generateInvoiceFabricStyleYearlyReport(1);
  };
  generateExcel = () => {
    this.generateInvoiceFabricStyleYearlyReport(2);
  };
  generateInvoiceFabricStyleYearlyReport = (reportType) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating ... ",
    });
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new InvoiceFabricStyleSoldYearlyInquiryDetailsRequest();
    listRequest.criteria = criteria;
    listRequest.input = reportBean;
    if (reportBean.reportType == 1) {
      ReportService.generateInvoiceFabricStyleSoldYearlyInquiryDetailsReport(
        listRequest,
        this.generateInvoiceFabricStyleYearlyResponse,
        this.errorCallBack
      );
    } else if (reportBean.reportType == 2) {
      ReportService.generateInvoiceFabricStyleSoldYearlyInquiryDetailsReport(
        listRequest,
        this.generateInvoiceFabricStyleYearlyResponse,
        this.errorCallBack
      );
    }
  };
  generateInvoiceFabricStyleYearlyResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowFabricStyleModule: isOpen,
      isShowCustomerModule: isOpen,
      moduleForPopup: [],
    });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewFabricModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowFabricStyleModule: true,
          moduleForPopup: (
            <PopupFabricStyleModule
              fabricStyleCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewCustomerModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCustomerModule: true,
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };

  /**
   * FIX (autocomplete stops working after the field is cleared):
   *
   * 1. The cleared value is now reset to "" instead of " ". A single space
   *    is not an empty value as far as the InputTextbox is concerned, so the
   *    next keystroke produced " te" and every *StartsWith search matched
   *    nothing - the list looked dead even though the service was called.
   * 2. showAutoCompleteFabricList is left TRUE on clear (and set through
   *    setState rather than mutated in place), so autocomplete stays armed
   *    for the next search instead of being switched off permanently.
   * 3. The search string is trimmed before it is sent to the service.
   */
  fabricCodeOnChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    const searchString = (value || "").trim();

    // Work on a single clone of main_bean for the whole handler (instead of
    // mutating this.state.main_bean in place) so nothing else that may be
    // holding this same object - e.g. a row inside criteria.fabricStyleDetails
    // - gets silently edited as a side effect of typing here.
    const criteria = { ...this.state.main_bean };
    criteria[name] = value;

    if (isEmptyString(searchString)) {
      // Empty string, NOT " ". Storing a space here is what poisoned every
      // subsequent search.
      criteria.fabricStyleCode = "";
      criteria.fabricStyleName = "";
      criteria.colorCodes = [];

      this.setState({
        main_bean: criteria,
        fabricPageListForAutoCompleteList: [],
        fabricColourPageListForAutoCompleteList: [],
        // Stay armed: the user is about to type the next search term.
        showAutoCompleteFabricList: true,
        isShowColorLookup: false,
      });
      return;
    }

    this.setState({
      main_bean: criteria,
      showAutoCompleteFabricList: true,
    });

    if (name === "fabricStyleCode") {
      this.loadFabricBySearchString(searchString);
    }
  };
  loadFabricStyleDetailResponse = (response, existingColorCodes = []) => {
    // Clone instead of mutating this.state.main_bean directly - main_bean
    // may be aliased elsewhere (e.g. right after a row was reopened), and
    // in-place edits here would silently change that other reference too.
    let criteria = { ...this.state.main_bean };
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      if (!isEmpty(fabricStyle)) {
        criteria.fabricStyleCode = fabricStyle.code;
        criteria.fabricStyleName = fabricStyle.description;

        const allColors = fabricStyle.colors || [];

        // Split the full color list: colors already selected for this
        // Fabric Style go to "Selected Colors", everything else goes to
        // "Colors" (available). This keeps the two tables in sync and
        // avoids the same color showing up in both, or being lost when the
        // popup is reopened via the Fabric Style hyperlink.
        const selectedMultipleColorList = allColors.filter((clr) =>
          existingColorCodes.includes(clr.fabricStyleColorCode)
        );
        const colorList = allColors.filter(
          (clr) => !existingColorCodes.includes(clr.fabricStyleColorCode)
        );

        // Single setState call: both tables and the loading indicator update
        // together in one render instead of two, so the popup doesn't flash
        // an intermediate state before settling on the final data.
        this.setState({
          main_bean: criteria,
          colorList: colorList,
          selectedMultipleColorList: selectedMultipleColorList,
          isShowColorPopUp: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        return;
      }
    }
    // No fabric style data returned - just clear the loading indicator.
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  loadFabricStyleDetail = (fabricStyleCode) => {
    const code = (fabricStyleCode || "").trim();
    if (isEmptyString(code)) {
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
      return;
    }

    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = code;
    input.isLoadChildren = true;

    // Same as the Fabric Style hyperlink flow: if this Fabric Style was
    // already added to the catalog (criteria.fabricStyleDetails), pull its
    // previously saved colorCodes here so the popup's Colors/Selected
    // Colors tables come up correctly split, instead of treating every
    // color as unselected.
    let criteria = this.state.criteria;
    let existingRecord =
      criteria && !isEmptyArray(criteria.fabricStyleDetails)
        ? criteria.fabricStyleDetails.find(
            (detail) => detail.fabricStyleCode === code,
          )
        : null;
    const existingColorCodes =
      existingRecord && !isEmptyArray(existingRecord.colorCodes)
        ? existingRecord.colorCodes
        : [];

    FabricStyleService.readFabricStyle(
      input,
      (response) =>
        this.loadFabricStyleDetailResponse(response, existingColorCodes),
      this.errorCallBack
    );
  };

  /**
   * Trims the search string and short-circuits on an empty one, so a stray
   * space can never be sent as *StartsWith (which would match nothing and
   * make the dropdown look broken).
   */
  loadFabricBySearchString(searchString) {
    const code = (searchString || "").trim();
    if (isEmptyString(code)) {
      this.setState({ fabricPageListForAutoCompleteList: [] });
      return;
    }

    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = code;
    searchCriteria.fabricStyleNameStartsWith = code;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = code;
    input.searchCriteria = searchCriteria;

    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.loadFabricCodeResponse,
      this.errorCallBack
    );
  }

  /**
   * Always writes a list (possibly empty). The previous version only called
   * setState inside the success branch, so an empty response left the
   * previous search's suggestions on screen.
   */
  loadFabricCodeResponse = (response) => {
    const fabricStyles =
      (response &&
        response.data &&
        response.data.fabricStylePageList &&
        response.data.fabricStylePageList.fabricStyles) ||
      [];

    const simpleAutoCompleteList = fabricStyles.map((fabricStyle) => ({
      code: fabricStyle.fabricStyleCode,
      description: fabricStyle.fabricStyleName,
    }));

    this.setState({
      fabricPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  fabricEnterKeyEventHandler = (e) => {
    const fabricStyleCode = (e.target.value || "").trim();
    if (isEmptyString(fabricStyleCode)) {
      return;
    }

    this.loadFabricStyleDetail(fabricStyleCode);

    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.state.is3PL ? "read Item" : "read Fabric",
      // The popup is now pre-populated with this Fabric Style's complete
      // previous color selection (see loadFabricStyleDetail), the same as
      // when it's reopened via the hyperlink. So on Add Catalog it should
      // replace the saved colorCodes outright rather than merge - merging
      // would silently restore any color the user just unselected.
      isReopenedViaHyperlink: true,
      // Close the dropdown for this selection but leave the flag ready to be
      // re-enabled by the next keystroke in fabricCodeOnChange.
      fabricPageListForAutoCompleteList: new Array(),
    });
  };

  /**
   * FIX: the argument is now honoured. CriteriaView used to call this with
   * no argument, so state was set to `undefined`, showAutoCompleteList went
   * permanently falsy, and the dropdown could never render again.
   */
  displayAutoCompleteFabricList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricList: showAutoCompleteList === true });
  };
  showHideSecondHeader = (e) => {
    if (e.detail === 1) {
      let isCollapsible_open = !this.state.isCollapsible_open;
      this.setState({ isCollapsible_open: isCollapsible_open });
    }
  };
  readMultiFabricBySearchString(searchString) {
    const code = (searchString || "").trim();
    if (isEmptyString(code)) {
      this.setState({ multiFabricPageListForAutoCompleteList: [] });
      return;
    }

    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = code;
    searchCriteria.fabricStyleNameStartsWith = code;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = code;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.readByMultiFabricCodeResponse,
      this.errorCallBack
    );
  }
  readByMultiFabricCodeResponse = (response) => {
    const fabricStyleData =
      (response &&
        response.data &&
        response.data.fabricStylePageList &&
        response.data.fabricStylePageList.fabricStyles) ||
      [];

    const simpleAutoCompleteList = fabricStyleData.map((fabricStyle) => ({
      code: fabricStyle.fabricStyleCode,
      description: fabricStyle.fabricStyleName,
    }));

    this.setState({
      multiFabricPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  multiFabricOnKeydown = (e) => {
    let criteria = this.state.criteria;
    criteria.multiFabricCode = e.target.value;
    this.state.criteria = criteria;
    if (e.keyCode == 9) {
      let valid = this.fabricFound();
      if (!valid) {
        this.readFabricStyle(e.target.value.toUpperCase());
      }
    }
  };
  readFabricStyleResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      criteria.multiFabricCode = fabricStyle.code;
      this.setState({ fabricStyleData: fabricStyle });
    } else {
      this.fabricFound();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readFabricStyle = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    FabricStyleService.readFabricStyle(
      input,
      this.readFabricStyleResponse,
      this.errorCallBack
    );
  };
  fabricFound = () => {
    let criteria = this.state.criteria;
    let errMsg = "";
    let errList = [];
    let valid = false;

    let multiFabricList =
      this.state.multiFabricPageListForAutoCompleteList.filter(
        (ln) => ln.code == criteria.multiFabricCode.toUpperCase()
      );
    let multiFabricCode = "";
    multiFabricList.map((ln) => {
      multiFabricCode = ln.code;
    });

    if (criteria.multiFabricCode.toUpperCase() != multiFabricCode) {
      errMsg = "InValid Item";
      errList.push(errMsg);
      valid = true;
    }

    if (errList.length > 0) {
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    return valid;
  };
  multiFabricEnterKeyEventHandler = (e) => {
    this.readFabricStyle(e.target.value);
    this.setState({ multiFabricPageListForAutoCompleteList: new Array() });
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Reading ...",
    });
  };
  displayAutoCompleteMultiFabricList = (showAutoCompleteMultiFabricList) => {
    this.setState({
      showAutoCompleteMultiFabricList:
        showAutoCompleteMultiFabricList === true,
    });
  };
  multifabricCodeOnChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    const searchString = (value || "").trim();

    const tempCriteria = { ...this.state.criteria };
    tempCriteria[name] = value;

    if (isEmptyString(searchString)) {
      // Same fix as fabricCodeOnChange: reset to "" and stay armed.
      tempCriteria.multiFabricCode = "";
      this.setState({
        showAutoCompleteMultiFabricList: true,
        criteria: tempCriteria,
        multiFabricPageListForAutoCompleteList: [],
        fabricStyleData: new FabricStyleBean(),
      });
      return;
    }

    this.setState({
      criteria: tempCriteria,
      showAutoCompleteMultiFabricList: true,
    });

    if (name === "multiFabricCode") {
      this.readMultiFabricBySearchString(searchString);
    }
  };
  deleteFabricStyleDetail = (e, val, rowData) => {
    let criteria = { ...this.state.criteria };
    // Filter out only the row that was clicked (matched by its unique
    // fabricStyleCode) and leave every other row untouched. Building a
    // brand-new array with filter (rather than splicing the existing one
    // in place) also gives React a new reference so the table re-renders
    // with exactly that row removed.
    criteria.fabricStyleDetails = criteria.fabricStyleDetails.filter(
      (detail) => detail.fabricStyleCode !== rowData.fabricStyleCode,
    );
    this.setState({ criteria: criteria });
  };
  deleteFabric = (line) => {
    let criteria = this.state.criteria;
    let lineData = criteria.fabricStyleCodes;
    let fabricDatas = this.state.fabricDatas;
    fabricDatas.map((list, index) => {
      if (list.code === line.code) {
        lineData.splice(index, 1);
        fabricDatas.splice(index, 1);
      }
    });
    this.setState({
      criteria: criteria,
      fabricDatas: fabricDatas,
      fabricStyleData: new FabricStyleBean(),
    });
  };
  addFabric = () => {
    let criteria = this.state.criteria;
    criteria.multiFabricCode = "";
    criteria.companyCode = this.companyCode;
    let fabricStyleData = this.state.fabricStyleData;
    let fabricDatas = this.state.fabricDatas;
    if (fabricStyleData != null) {
      if (!isEmptyArray(fabricDatas) && !isEmptyString(fabricStyleData.code)) {
        let exists = fabricDatas.find((p) => p.code === fabricStyleData.code);
        if (!exists) {
          fabricDatas.push(fabricStyleData);
          criteria.fabricStyleCodes.push(fabricStyleData.code);
          this.setState({
            criteria: criteria,
            fabricDatas: fabricDatas,
            fabricStyleData: new FabricStyleBean(),
            multiFabricPageListForAutoCompleteList: [],
            showAutoCompleteMultiFabricList: true,
          });
        }
      } else {
        if (!isEmptyString(fabricStyleData.code)) {
          fabricDatas.push(fabricStyleData);
          criteria.fabricStyleCodes.push(fabricStyleData.code);
          this.setState({
            criteria: criteria,
            fabricDatas: fabricDatas,
            fabricStyleData: new FabricStyleBean(),
            multiFabricPageListForAutoCompleteList: [],
            showAutoCompleteMultiFabricList: true,
          });
        }
      }
    }
  };
  getCaption = (colorCodes) => {
    return (colorCodes || []).join(", ");
  };

  handleLineNumberClick = (e, val, rowData) => {
    // Colors already selected for this Fabric Style (from the CustomTable row).
    // Captured here in a closure so the response handler can split the freshly
    // fetched color list into "already selected" vs "still available", instead
    // of relying on state that may not have committed yet.
    const existingColorCodes = !isEmptyArray(rowData.colorCodes)
      ? rowData.colorCodes
      : [];

    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = val;
    input.isLoadChildren = true;
    FabricStyleService.readFabricStyle(
      input,
      (response) =>
        this.loadFabricStyleDetailResponse(response, existingColorCodes),
      this.errorCallBack
    );
    this.setState({
      isShowColorPopUp: true,
      // Clone rowData instead of storing the exact table-row object in
      // main_bean. main_bean also backs the top-level FabricStyle
      // InputTextbox, so without cloning, typing there would mutate this
      // same object in place - and since it's literally the row inside
      // criteria.fabricStyleDetails, the CustomTable would update live too.
      main_bean: { ...rowData },
      // Clear the previous Fabric Style's colors right away and show a loading
      // indicator instead of leaving the old colorList/selectedMultipleColorList
      // on screen until the fetch resolves - that stale-then-correct flash is
      // what makes the popup feel slow to populate.
      colorList: [],
      selectedMultipleColorList: [],
      isShowProgressBarPopup: true,
      progressLoadingText: "Loading Colors...",
      isReopenedViaHyperlink: true,
      // A row was clicked, so any leftover suggestion list is stale.
      fabricPageListForAutoCompleteList: [],
    });
  };

  inquiryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("FabricStyle", "fabricStyleCode", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.handleLineNumberClick, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Colors", "colorCodes", true)
        .setStatusDetails(true, this.getCaption)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("", <DeleteIcon />, false)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(false, true, this.deleteFabricStyleDetail, <DeleteIcon />)
        .setDisabled(""),
    );

    return columns;
  };
  MultipleAddLines = (e) => {
    if (e.detail == 1) {
      let main_bean = { ...this.state.main_bean };
      let criteria = { ...this.state.criteria };

      criteria.companyCode = this.companyCode;
      if (!isEmptyArray(this.state.selectedMultipleColorList)) {
        let selectedMultipleColorList = this.state.selectedMultipleColorList;

        main_bean.colorCodes = selectedMultipleColorList.map(
          (color) => color.fabricStyleColorCode
        );
        main_bean.companyCode = this.companyCode;

        // Check whether this Fabric Style already exists in fabricStyleDetails
        const existingIndex = criteria.fabricStyleDetails.findIndex(
          (detail) => detail.fabricStyleCode === main_bean.fabricStyleCode
        );

        if (existingIndex === -1) {
          // Fabric Style not present yet - add a new record
          criteria.fabricStyleDetails.push(main_bean);
        } else if (this.state.isReopenedViaHyperlink) {
          // Popup was reopened via the Fabric Style hyperlink: colorList and
          // selectedMultipleColorList were pre-populated with the row's full
          // previous selection, so selectedMultipleColorList right now IS the
          // complete, authoritative set of colors for this row (including any
          // colors the user just unselected being correctly left out).
          // Replace the saved colorCodes outright - do NOT union with the old
          // value, or an unselected color would never actually be removed.
          const existingRecord = { ...criteria.fabricStyleDetails[existingIndex] };
          existingRecord.colorCodes = [...new Set(main_bean.colorCodes)];

          const updatedFabricStyleDetails = [...criteria.fabricStyleDetails];
          updatedFabricStyleDetails[existingIndex] = existingRecord;
          criteria.fabricStyleDetails = updatedFabricStyleDetails;
        } else {
          // Fresh typed entry for a Fabric Style that already has a saved
          // row: selectedMultipleColorList only holds colors picked in this
          // session, so union them with what was already saved instead of
          // replacing it.
          const existingRecord = { ...criteria.fabricStyleDetails[existingIndex] };
          const mergedColorCodes = [
            ...new Set([
              ...(existingRecord.colorCodes || []),
              ...main_bean.colorCodes,
            ]),
          ];
          existingRecord.colorCodes = mergedColorCodes;

          const updatedFabricStyleDetails = [...criteria.fabricStyleDetails];
          updatedFabricStyleDetails[existingIndex] = existingRecord;
          criteria.fabricStyleDetails = updatedFabricStyleDetails;
        }

        this.setState({
          // Reset to a fresh bean so both FabricStyle InputTextboxes clear
          // after a successful Add Catalog. This is a brand-new object, so
          // it can't affect the record just saved into criteria.fabricStyleDetails.
          //
          // fabricStyleCode/fabricStyleName are set explicitly here rather
          // than relying solely on the class constructor: the constructor
          // in ds.inquiry.criteria.FabricStyleCatalogueProductDetailCriteria
          // currently defines the code field as "FabricStyleCode" (wrong
          // casing) and doesn't define fabricStyleName at all, so without
          // this, main_bean.fabricStyleName would come back undefined and
          // React would stop controlling that input - leaving whatever text
          // was last typed sitting in the DOM instead of clearing it.
          main_bean: Object.assign(new FabricStyleCatalogueProductDetailCriteria(), {
            fabricStyleCode: "",
            fabricStyleName: "",
            colorCodes: [],
          }),
          criteria: criteria,
          isShowColorPopUp: false,
          isReopenedViaHyperlink: false,
          colorList: [],
          selectedMultipleColorList: [],
          // Re-arm autocomplete for the next fabric. The imperative
          // .clear() below does not fire onChange, so without these two the
          // very next search after an Add Catalog would return no
          // suggestions.
          fabricPageListForAutoCompleteList: [],
          showAutoCompleteFabricList: true,
        });

        this.resetFabricAutoComplete();
      } else {
        let errList = [];
        let errMsg = "Select Colors!"
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowColorLineAlert: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
  };
  selectColor = (e, val, color, rowIndex) => {
    // Functional setState: always computed from the latest state, so rapid
    // clicks or overlapping updates never operate on a stale colorList /
    // selectedMultipleColorList snapshot.
    this.setState((prevState) => {
      const alreadySelected = prevState.selectedMultipleColorList.some(
        (clr) => clr.fabricStyleColorCode === color.fabricStyleColorCode
      );

      const colorList = prevState.colorList.filter(
        (clr) => clr.fabricStyleColorCode !== color.fabricStyleColorCode
      );

      // Guard against adding a duplicate record if this color is somehow
      // already present in selectedMultipleColorList.
      const selectedMultipleColorList = alreadySelected
        ? prevState.selectedMultipleColorList
        : [...prevState.selectedMultipleColorList, color];

      return { colorList, selectedMultipleColorList };
    });
  }
  unSelectColor = (e, val, color, rowIndex) => {
    // Functional setState: always computed from the latest state, so rapid
    // clicks or overlapping updates never operate on a stale colorList /
    // selectedMultipleColorList snapshot. This is what makes the Unselect
    // action move the color immediately and correctly, every time.
    this.setState((prevState) => {
      const selectedMultipleColorList = prevState.selectedMultipleColorList.filter(
        (clr) => clr.fabricStyleColorCode !== color.fabricStyleColorCode
      );

      // Guard against adding a duplicate record if this color is somehow
      // already present in colorList.
      const alreadyInColorList = prevState.colorList.some(
        (clr) => clr.fabricStyleColorCode === color.fabricStyleColorCode
      );
      const colorList = alreadyInColorList
        ? prevState.colorList
        : [...prevState.colorList, color];

      return { colorList, selectedMultipleColorList };
    });
  };

  colorColumn = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setDetails("", <AddIcon />, false)
        .setClickDetails(false, true, this.selectColor, <AddIcon />)
        .setDetails("", "fabricStyleColorCode", true)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ColorCode", "fabricStyleColorCode", true)
        .setStyleDetails("left", "", "", "min-wt-5", "min-wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ColorCode", "fabricStyleColorName", true)
        .setStyleDetails("left", "", "", "min-wt-5", "min-wt-5"),
    );
    return columns;
  };
  unColorColumn = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setDetails("", <CancelIcon />, false)
        .setClickDetails(false, true, this.unSelectColor, <CancelIcon />)
        .setDetails("", "fabricStyleColorCode", true)
        .setStyleDetails("", "", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ColorCode", "fabricStyleColorCode", true)
        .setStyleDetails("left", "", "", "min-wt-5", "min-wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ColorCode", "fabricStyleColorName", true)
        .setStyleDetails("left", "", "", "min-wt-5", "min-wt-5"),
    );
    return columns;
  };
  selectAllColors = () => {
    this.setState((prevState) => ({
      colorList: [],
      selectedMultipleColorList: [
        ...prevState.selectedMultipleColorList,
        ...prevState.colorList,
      ],
    }));
  };

  unselectAllColors = () => {
    this.setState((prevState) => ({
      colorList: [
        ...prevState.colorList,
        ...prevState.selectedMultipleColorList,
      ],
      selectedMultipleColorList: [],
    }));
  };
  render() {
    let inquiryDataList = this.state.inquiryDataList;
    let colorList = this.state.colorList;
    let selectedMultipleColorList = this.state.selectedMultipleColorList;
    let criteria = this.state.criteria;
    let main_bean = this.state.main_bean;

    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          pageTitle={"Fabric Catalog Generation"}
          isShowExitButton={this.state.isShowExitButton}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowResetButton={this.state.isShowResetButton}
          onModuleExit={this.onModuleExit}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          // reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
        />
        <CriteriaView
          {...this.state}
          onChange={this.onChange}
          fabricCodeRef={this.fabricCodeRef}
          fabricCodeOnChange={this.fabricCodeOnChange}
          fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
          displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
          showHideSecondHeader={this.showHideSecondHeader}
          multifabricCodeOnChange={this.multifabricCodeOnChange}
          addFabric={this.addFabric}
          deleteFabric={this.deleteFabric}
          multiFabricOnKeydown={this.multiFabricOnKeydown}
          multiFabricEnterKeyEventHandler={this.multiFabricEnterKeyEventHandler}
          displayAutoCompleteMultiFabricList={
            this.displayAutoCompleteMultiFabricList
          }
          multiFabricCodeRef={this.multiFabricCodeRef}
        />
        <div className="mt-3">
          <CustomTable
            data={criteria.fabricStyleDetails}
            columns={this.inquiryColumns()}
          />
        </div>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowFabricStyleModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />

        <MultiViewPopup
          popupLvlClass={"popupSizeLevel0"}
          isModulePopup={false}
          isShowPopup={this.state.isShowColorPopUp}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertMultipleColorModalCallBack}
          title={"Colors"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          lockScroll={true}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowColorLineAlert}
              hideAlertCallBack={this.hideAlertCallBackColor}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.MultipleAddLines(e)}
              >
                Add Catalog
              </Button>
            </div>
          }
          content={
            <div>
              <Row>
                <Col sm="1">
                  <FormLabel>FabricStyle</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleCode"
                    value={main_bean.fabricStyleCode}
                    disable={true}
                  />
                </Col>
              </Row>

              <div style={{ marginBottom: '10px', marginTop: '10px' }}>
                <Button
                  className="header_buttons"
                  size="sm"
                  onClick={this.selectAllColors}
                >
                  Select All
                </Button>
                <Button
                  className="header_buttons"
                  size="sm"
                  onClick={this.unselectAllColors}
                  style={{ marginLeft: '5px' }}
                >
                  Unselect All
                </Button>
              </div>

              <div className="multi-clr-div">
                <div className="multi-clr-tble">
                  <CustomTable
                    data={colorList}
                    columns={this.colorColumn()}
                    label={"Colors"}
                  />
                </div>
                <div className="multi-clr-tble">
                  <CustomTable
                    data={selectedMultipleColorList}
                    columns={this.unColorColumn()}
                    label={"Selected Colors"}
                  />
                </div>
              </div>
            </div>
          }
        />
      </div>
    );
  }
}
export function CriteriaView(props) {
  const fabricCodeOnChange = (e) => props.fabricCodeOnChange(e);
  const onChange = (e) => props.onChange(e);
  let colorCodeRef = React.createRef();
  let criteria = props.criteria;
  let main_bean = props.main_bean;
  let fabricLookupHandler = props.fabricLookupHandler;
  const fabricCodeRef = props.fabricCodeRef;
  const multiFabricCodeRef = props.multiFabricCodeRef;
  const fabricEnterKeyEventHandler = (e) => {
    props.fabricEnterKeyEventHandler(e);
  };

  // FIX: forward the argument. Previously this called the parent handler
  // with no argument, which set showAutoCompleteFabricList to `undefined` -
  // permanently falsy - so the dropdown never rendered again after the first
  // time InputTextbox asked to hide it.
  const displayAutoCompleteFabricList = (showAutoCompleteList) => {
    props.displayAutoCompleteFabricList(showAutoCompleteList);
  };

  const multifabricCodeOnChange = (e) => {
    props.multifabricCodeOnChange(e);
  };
  const displayAutoCompleteMultiFabricList = (showAutoCompleteList) => {
    props.displayAutoCompleteMultiFabricList(showAutoCompleteList);
  };
  const multiFabricEnterKeyEventHandler = (e) => {
    props.multiFabricEnterKeyEventHandler(e);
  };
  const addFabric = (e) => {
    if (e.detail === 1) {
      props.addFabric();
      if (multiFabricCodeRef.current != null) {
        multiFabricCodeRef.current.clear();
        multiFabricCodeRef.current.focus();
      }
    }
  };
  const deleteFabric = (e, val, line) => {
    props.deleteFabric(line);
  };
  const fabricColumnDefinitions = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(props.is3PL ? "Item#" : "FabricStyle", "code", true)
        .setStyleDetails("left")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("", <DeleteIcon />, false)
        .setClickDetails(false, true, deleteFabric, <DeleteIcon />)
    );

    return columns;
  };

  return (
    <div>
      <Row className="d-flex justify-context-left">
        <Col sm="1">
          {props.is3PL ? (
            <FormLabel>Item</FormLabel>
          ) : (
            <FormLabel>FabricStyle</FormLabel>
          )}
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={fabricCodeRef}
            name="fabricStyleCode"
            value={main_bean.fabricStyleCode}
            lookupRequired={props.isShowLookUp}
            showCriteriaDialog={true}
            onChange={fabricCodeOnChange}
            lookupHandler={fabricLookupHandler}
            enterKeyEventHandler={fabricEnterKeyEventHandler}
            autoCompleteListData={props.fabricPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteFabricList}
            showAutoCompleteList={props.showAutoCompleteFabricList}
            disabled={!props.isShowLookUp}
          />
        </Col>
        <Col sm="2">
          <InputTextbox
            disabled={true}
            name="fabricStyleName"
            value={main_bean.fabricStyleName}
          />
        </Col>
      </Row>
    </div>
  );
}
function FabricCatalogGeneration(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App">
        <FabricCatalog {...props} name="" /> <br />
      </div>
    </div>
  );
}
export default FabricCatalogGeneration;